import { useEffect, useState } from "react"

import type { Preset } from "simplydo/react/richtext/Remirror/types"

import Dropdown from "./Dropdown"
import useMention from "./useMention"

const mapToName = (list) =>
  list
    .filter((i) => i.name === "mention")
    .map((i) => i.config)
    .reduce((p, c) => {
      p[c.name] = c
      return p
    }, {})

export type RemirrorMention = {
  [key: string]: any
  name: string
  priority: number
  appendText?: string
}

export type RemirrorMentionProps = {
  mentions: Record<string, Array<RemirrorMention>>
  options: Preset

  // Does not directly return mentions but just acts as a trigger to load mentions which are passed in via state
  onSuggest: (kind: Array<string>, query: string) => void
  onMentionSelect?: (mention: RemirrorMention) => void
}

/**
 * The mention components
 *
 * @param mentions - a map of name to available mentions
 * @param config - the configuration objects used to initialise the mention extension
 * @param onMentionSelect - Will receive the selected mention as a parameter
 */
const Mentions = ({ mentions, options, onSuggest, onMentionSelect }: RemirrorMentionProps) => {
  const [mappedConfig, setMappedConfig] = useState<Record<Preset[number]["name"], Preset[number]>>(() =>
    mapToName(options),
  )

  useEffect(() => {
    setMappedConfig(mapToName(options))
  }, [options])

  const mentionProps = useMention({
    allMentions: mentions,
    config: mappedConfig,
    onSuggest,
    onMentionSelect,
  })

  return <Dropdown {...mentionProps} />
}

export default Mentions
